module.exports = __webpack_public_path__ + "img/84.895bcfe2.jpg";